import React from 'react'

const Footer = () => (
  <footer>
    <p className="center">&copy; Slick's Slices {new Date().getFullYear()}</p>
  </footer>
)
export default Footer
